// delay 
const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

const delayOnScroll = (func, delay) => {
    let timeoutId;
    return (...args) => {
        clearTimeout(timeoutId);
        timeoutId = setTimeout(() => {
            func.apply(null, args);
        }, delay);
    };
};

const trashIcon = `
<svg width="100%" height="100%" viewBox="0 0 18 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M11 8V15M7 8V15M3 4V15.8C3 16.9201 3 17.4798 3.21799 17.9076C3.40973 18.2839 3.71547 18.5905 4.0918 18.7822C4.5192 19 5.07899 19 6.19691 19H11.8031C12.921 19 13.48 19 13.9074 18.7822C14.2837 18.5905 14.5905 18.2839 14.7822 17.9076C15 17.4802 15 16.921 15 15.8031V4M3 4H5M3 4H1M5 4H13M5 4C5 3.06812 5 2.60241 5.15224 2.23486C5.35523 1.74481 5.74432 1.35523 6.23438 1.15224C6.60192 1 7.06812 1 8 1H10C10.9319 1 11.3978 1 11.7654 1.15224C12.2554 1.35523 12.6447 1.74481 12.8477 2.23486C12.9999 2.6024 13 3.06812 13 4M13 4H15M15 4H17" stroke="#9c9c9c" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
`;

const sizeToLetter = (size) => {
    const s = String(size).toLowerCase();
    switch (s) {
        case 'xs':
            return 'X-Small';
        case 's':
            return 'Small';
        case 'm':
            return 'Medium';
        case 'l':
            return 'Large';
        case 'xl':
            return 'X-Large';
        default:
            return size;
    }
}

const formatCartMoney = (amount) => {

    const formatter = new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
    });
  
    const formattedPrice = formatter.format(amount / 100);
    return formattedPrice;
}

const rebuildProductAccessories = (accessories) => {
    // loop accessories check if product_type is accessories and append to parts container cart-main-items-inner-container part-items ul
    var partItems = accessories.filter(part => part.product_type === 'accessories' || part.product_type === 'gear' ||  part.product_type === 'outlet' ||  part.product_type === '');
    // console.log('partItems: ', partItems);
    $('.cart-main-items-inner-container.part-items ul').empty();
    partItems.forEach(part => {
        var partItem = `
        <li>
            <div class="cart-item-image-container cart-accessories ${part.image == null && 'hidden'}">
            <img src="${part.image}" height="1000" width="1000" alt="product-image">
            </div>
            <div class="cart-item-actions-container">
            <h4>${part.title.split('-')[1].trim()}</h4>
            <p>${part.price === 0 ? 'Included': 'Price: <span>'+formatCartMoney(part.price)+'</span>'}</p>
            <p>Quantity: <span>${part.quantity}</span></p>
            <a data-cart-key="${part.key}" href="#!"><div class="cart-action-icon">${trashIcon}</div><span>Remove</span></a>
            </div>
        </li>
        `;
        $('.cart-main-items-inner-container.part-items ul').append(partItem);
    });

    $('.cart-main-items-inner-container.part-items').removeClass('hidden');
}

const buildProductBike = (bike) => {
    if (bike == undefined) {
        $('[data-bike-layout]').addClass('hidden');
        return false;
    }
    // Change cart image to bike image
    $('[data-bike-layout]').find('.cart-item-image-container img').attr('src', bike.image);
            
    $('[data-bike-layout]').find('.cart-item-image-container').removeClass('loading-skeleton');

    // Set product title
    $('[data-bike-layout]').find('.cart-item-details-container h3').text(bike.product_title);
    $('[data-bike-layout]').find('.cart-item-details-container h3').removeClass('loading-skeleton');

    $('[data-bike-layout]').find('.cart-item-details-container [data-build-title] > span').text(bike.variant_title);
    $('[data-bike-layout]').find('.cart-item-details-container [data-build-title]').removeClass('loading-skeleton');

    $('[data-bike-layout]').find('.cart-item-details-container [data-properties-color] > span').text(bike.properties['Frame Color']);
    $('[data-bike-layout]').find('.cart-item-details-container [data-properties-color]').removeClass('loading-skeleton');

    $('[data-bike-layout]').find('.cart-item-details-container [data-properties-frame-size] > span').text(sizeToLetter(bike.properties['Bike Size']));
    $('[data-bike-layout]').find('.cart-item-details-container [data-properties-frame-size]').removeClass('loading-skeleton');

    // Set Selected Variant Image
    $('[data-bike-layout]').find('.cart-item-image-container img').attr('src', bike.properties['Bike Image']);
    // set cart rebuild link
    $('[data-bike-layout]').find('[data-cart-rebuild]').attr('href', `/pages/build?bike=${bike.handle}`);

    // remove cart notes skeleton
    $('[data-bike-layout]').find('.cart-item-notes-container').removeClass('loading-skeleton'); 
}

const buildProductGears = (gears) => {
    if (gears == undefined) {
        $('[data-gears-layout]').addClass('hidden');
        return false;
    }

    gears = gears.filter(gear => gear.product_type === 'gear' || gear.product_type === 'outlet');

    $('.cart-main-left-layout-container').empty();
    gears.forEach(gear => {
        let options = "";
        gear.options_with_values.forEach(option => {
            // console.log('option: ', option);
            options += `<p class="${option.name !== 'Size' ? 'hidden': ''}">${option.name}: <span>${option.value}</span></p>`;
        });
        let gearItem = `
        <div data-gear-layout class="cart-main-items-inner-container">
            <div class="cart-item-image-container">
                <img src="${gear?.featured_image?.url}" height="${gear?.featured_image?.height}" width="${gear?.featured_image?.width}" alt="${gear?.featured_image?.alt}">
            </div>
            <div class="cart-item-details-group">
                <div class="cart-item-details-container">
                <h3>${gear.title}</h3>
                <p>Price: <span>${formatCartMoney(gear.price)}</span></p>
                ${options}
                <p>Quantity: <span>${gear.quantity}</span></p>
                </div>
                <div class="cart-item-actions-container">
                <a data-cart-remove href="/cart/clear"><div class="cart-action-icon">${trashIcon}</div><span>Remove</span></a>
                </div>
            </div> 
        </div>
        `;
        $('.cart-main-left-layout-container').append(gearItem);
    });
}

const clearAccesorriesOnCart = async (accessories) => {
    // console.log('removing accessories on cart');

    // loop accessories check if product_type is accessories and create a new object with id and quantity
    let romveAccessories = accessories.map(accessory => {
        if (accessory.product_type === 'accessories') {
            return {
                id: accessory.key,
                quantity: 0
            }
        }
    });
    try {
        const request = await fetch('/cart/update.js', {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(romveAccessories),
        });
        if(!request.ok) throw new Error('Failed to remove from cart');
        const response = await request.json();
        return response;
    } catch (error) {
        console.error('Error removing from cart:', error);
        return [];
    }
}


let isPositionFixed = false; // Variable to track the current position

const checkScrollPosition = () => {
    // let mainContainer = $('.cart-main-container');
    // let containerTop = mainContainer.offset().top;
    // let containerBottom = containerTop + mainContainer.outerHeight();
    // let windowHeight = $(window).height();
    // let scrollPosition = $(window).scrollTop(); // Current scroll position

    // if (containerBottom <= windowHeight + scrollPosition && !isPositionFixed) {
    //     $('.cart-actions-mobile-container').addClass('static').removeClass('float');
    //     $('#podium-bubble').removeClass('onfloat')
    //     isPositionFixed = true;
    //     } else if (containerBottom > windowHeight + scrollPosition && isPositionFixed) {
    //     $('.cart-actions-mobile-container').addClass('float').removeClass('static');
    //     $('#podium-bubble').addClass('onfloat')
    //     isPositionFixed = false;
    // }
}

// Refresh Bread Pay after the cart has finished rebuilding its items.
const updateBreadPayment = async (cartPrice) => {
    const containers = document.querySelectorAll('.bread-as-low-as-container');
    if (!containers.length) return;

    containers.forEach((container) => {
        container.dataset.price = cartPrice;
    });

    // The SDK loads independently of the cart script. Keep the financing link
    // available if it is slow or unavailable, and refresh once setup completes.
    if (!window.ariBreadReady) {
        document.addEventListener('ari:bread-ready', () => {
            updateBreadPayment(cartPrice);
        }, { once: true });
        return;
    }

    const money = { value: cartPrice, currency: 'USD' };
    const placements = Array.from(containers, (container) => ({
        allowCheckout: false,
        domID: container.id,
        order: {
            items: [],
            subTotal: money,
            totalPrice: money,
            currency: 'USD',
            totalShipping: { value: 0, currency: 'USD' },
            totalTax: { value: 0, currency: 'USD' },
            totalDiscounts: { value: 0, currency: 'USD' }
        }
    }));

    try {
        window.BreadPayments.registerPlacements(placements);
    } catch (error) {
        console.error('Unable to update Bread Pay cart messaging:', error);
    }
};

// document ready
document.addEventListener('DOMContentLoaded', function() {

    var cart = window.cart;
    var cartItems = window.cartItems;

    setTimeout(() => {
        $('#podium-bubble').addClass('onfloat');
    }, 1500);
    // check if cart items is empty
    if (cartItems.length === 0) {
        // remove cart header skeleton and add cart-empty class
        $('.cart-main-inner-container').addClass('cart-empty').find('h2').removeClass('loading-skeleton');

        $('.cart-main-actions-container').remove();

        $('.cart-main-items-container').html(`
        <div class="empty-cart-container">
            <p>${ window.cart_settings_empty_cart_message }</p>
            <a href="${window.cart_settings_continue_shopping_button_link}" class="empty-cart-button">${window.cart_settings_empty_cart_button_text}</a>
        </div>
        `);
        return false;
    }

    // find bike from cartItems
    var bike = cartItems.find(item => item.product_type === 'bike');

    // Wait 2 seconds before running the code use await instead of timeout
    (async () => {
        await delay(2000);
        // remove cart header skeleton
        $('.cart-main-inner-container').find('h2').removeClass('loading-skeleton');
        // remove cart actions children skeleton
        $('.cart-main-actions-container').find('.loading-skeleton').removeClass('loading-skeleton');

        // If there is a bike in the cart
        buildProductBike(bike);
        
        if (bike !== undefined) {

            // add bike custom fit attributes
            let height = bike.properties['Height'];
            if (height) {
                $('[data-height]').removeClass('hidden').find('span').text(height + ' in.');
                $('[data-body-measurements]').removeClass('hidden');
            }

            let weight = bike.properties['Weight'];
            if (weight) {
                $('[data-weight]').removeClass('hidden').find('span').text(weight + ' lbs.');
                $('[data-body-measurements]').removeClass('hidden');
            }

            let gender = bike.properties['Gender'];
            if (gender) {
                $('[data-gender').removeClass('hidden').find('span').text(gender);
                $('[data-body-measurements]').removeClass('hidden');
            }

            let age = bike.properties['Age'];
            if (age) {
                $('[data-age').removeClass('hidden').find('span').text(age + ' years');
                $('[data-body-measurements]').removeClass('hidden');
            }

            let inseam = bike.properties['Inseam'];
            if (inseam) {
                $('[data-inseam').removeClass('hidden').find('span').text(inseam + ' in.');
                $('[data-body-measurements]').removeClass('hidden');
            }

            let shoulderWidth = bike.properties['Shoulder Width'];
            if (shoulderWidth) {
                $('[data-shoulder-width').removeClass('hidden').find('span').text(shoulderWidth + ' in.');
                $('[data-body-measurements]').removeClass('hidden');
            }

            let armLength = bike.properties['Arm Length'];
            if (armLength) {
                $('[data-arm-length').removeClass('hidden').find('span').text(armLength + ' in.');
                $('[data-body-measurements]').removeClass('hidden');
            }

            let torso = bike.properties['Torso'];
            if (torso)  {
                $('[data-torso').removeClass('hidden').find('span').text(torso + ' in.');
            }

            let ridingPosition = bike.properties['Riding Position'];
            if (ridingPosition) {
                $('[data-riding-position').removeClass('hidden').find('span').text(ridingPosition);
                $('[data-body-measurements]').removeClass('hidden');
            }

            // add bike parts properties
            let wheelset = bike.properties['Wheelset'];
            if (wheelset) {
                $('[data-wheelset').removeClass('hidden').find('span').text(wheelset);
                $('[data-included]').removeClass('hidden');
            }

            let drivetrain = bike.properties['Drivetrain'];
            if (drivetrain) {
                $('[data-drivetrain').removeClass('hidden').find('span').text(drivetrain);
                $('[data-included]').removeClass('hidden');
            }

            let cyclingComputer = bike.properties['Cycling Computer'];
            if (cyclingComputer) {
                $('[data-cycling-computer').removeClass('hidden').find('span').text(cyclingComputer);
                $('[data-included]').removeClass('hidden');
            }

            let pedals = bike.properties['Pedals'];
            if (pedals) {
                $('[data-pedals').removeClass('hidden').find('span').text(pedals);
                $('[data-included]').removeClass('hidden');
            }

            let seatpost = bike.properties['Seatpost'];
            if (seatpost) {
                $('[data-seatpost').removeClass('hidden').find('span').text(seatpost);
                $('[data-included]').removeClass('hidden');
            }

            let flatProtection = bike.properties['Flat Protection'];
            if (flatProtection) {
                $('[data-flat-protection').removeClass('hidden').find('span').text(flatProtection);
                $('[data-included]').removeClass('hidden');
            }

            let frameProtection = bike.properties['Frame Protection'];
            if (frameProtection) {
                $('[data-frame-protection').removeClass('hidden').find('span').text(frameProtection);
                $('[data-included]').removeClass('hidden');
            }

            let assemblyKit = bike.properties['AssemblyKit'];
            if (assemblyKit) {
                $('[data-assembly-kit').removeClass('hidden').find('span').text(assemblyKit);
                $('[data-included]').removeClass('hidden');
            }

            let suspension = bike.properties['Suspension'];
            if (suspension) {
                $('[data-suspension').removeClass('hidden').find('span').text(suspension);
                $('[data-included]').removeClass('hidden');
            }
        }

        // if there is no bike in the cart print gears
        if (bike == undefined) {
            // remove all items on cart except for gears
            await clearAccesorriesOnCart(cartItems);

            buildProductGears(cartItems);
        } else {
            //rebuild product parts
            rebuildProductAccessories(cartItems);
        }

        // remove cart items skeleton
        $('.cart-item-actions-container').find('.loading-skeleton').removeClass('loading-skeleton');

        // set cart total
        $('.cart-subtotal--amount').find('[data-total-amount]').text(formatCartMoney(cart.total_price));

        // update bread payment
        await updateBreadPayment(cart.total_price);

        // Remove summary children skeleton
        $('.cart-main-right-container').find('.loading-skeleton').removeClass('loading-skeleton');

    })();

    // Check current scroll position
    checkScrollPosition();

    // Window On Scroll
    $(window).on('scroll', delayOnScroll(checkScrollPosition, 100));

    // Checkout button event
    $('[data-cart-action-checkout]').on('click', async function(e) {
        e.preventDefault();

        // disable the body
        $('body').addClass('disable-body');

        // update cart with cart note use fetch
        var cartNote = $('[data-cart-note]').val();
        // console.log('cartNote: ', cartNote);
        // update cart with note
        await fetch('/cart/update.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                note: cartNote
            })
        })
        $('body').removeClass('disable-body');
        window.location.href = '/checkout'; 
    });

    // Checkout button mobile event
    $('[data-cart-action-mobile-checkout]').on('click', function(e) {
        e.preventDefault();

        // disable the body
        $('body').addClass('disable-body');

        // update cart with cart note use fetch
        var cartNote = $('[data-cart-mobile-note]').val();
        // console.log('cartNote: ', cartNote);
        // update cart with note
        fetch('/cart/update.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                note: cartNote
            })
        })
        window.location.href = '/checkout';
    });

    $('[data-cart-remove]').on('click', function(e) {
        e.preventDefault();
        // clear the cart and reload
        fetch('/cart/clear.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            }
        }).then(() => {
            window.location.reload();
        });
    });

    $('[data-cart-clear]').on('click', function(e) {
        e.preventDefault();
        // clear the cart and reload
        fetch('/cart/clear.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            }
        }).then(() => {
            window.location.reload();
        });
    });

    // remove part item
    $('.cart-main-items-inner-container.part-items ul').on('click', 'a', function(e) {
        e.preventDefault();
        var cartKey = $(this).data('cart-key');
        // disable the body
        $('body').addClass('disable-body');
        // console.log('cartKey: ', cartKey);
        fetch('/cart/change.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                id: cartKey,
                quantity: 0
            })
        }).then(() => {
            // On reload scroll to top
            window.onbeforeunload = function () {
                window.scrollTo(0, 0);
            }
            window.location.reload();
        });
    });

});